import { ConfigurableTheme } from '../../styles/types';

export default {
  colors: {
    error: '#C82E2D',
    errorBackground: '#FCE8E8',
    errorDark: '#9f2322',

    background: '#ffffff',
    backgroundSecondary: '#ffffff',
    headerBackground: '#ffffff',
    headerText: '#000000',
    menuArrow: '#000000',
    modalBackdrop: 'rgba(0, 0, 0, 0.4)',

    secondary: '#000000',
    secondaryLight: 'rgba(0, 0, 0, 0.7)',
    secondarySupportLight: '#ffffff',
    secondarySupport: '#8a8a8a',

    action: '#000000',
    actionDark: '#616161',
    actionLight: '#88868b',
    actionLightest: '#a3a3a3',

    actionSecondary: '#ffffff',
    actionSecondaryDark: '#fafafa',
    actionSecondaryDarker: '#f5f5f5',

    actionText: '#ffffff',
    actionTextDark: 'rgba(0, 0, 0, 0.8)',
    actionTextLight: 'rgba(0, 0, 0, 0.5)',

    focusOutline: '#8a8a8a',

    inputBackground: '#ffffff',
    inputPlaceholderFocus: 'rgba(0, 0, 0, 0.2)',
    inputSupport: 'rgba(0, 0, 0, 0.2)',

    botMessageBackground: 'rgba(0, 0, 0, 0.07)',
    userMessageBackground: '#D6D6D6',
    messageText: '#000000',

    botActionBackground: '#ffffff',
    botActionText: '#000000',
    botActionBackgroundHover: 'rgba(0, 0, 0, 0.02)',
    botActionBackgroundActive: 'rgba(0, 0, 0, 0.02)',

    calendarItemHover: '#ffffff',
    calendarItemBackgroundHover: '#616161',
    calendarItemCurrent: '#e8e8e8',
    calendarItemSelected: '#ffffff',
    calendarItemSelectedBackground: '#000000',
    calendarItemOutside: 'rgba(0, 0, 0, 0.2)',
    calendarSecondaryItem: '#616161',

    borderDark: 'rgba(0, 0, 0, .6)',
    borderMedium: 'rgba(0, 0, 0, .4)',
    borderLight: 'rgba(0, 0, 0, .18)',
  },
  fonts: {
    fontStack: '"se-motor-audi"',
  },
} as ConfigurableTheme;
